import { FinancesContainer } from "../Containers/FinancesContainer"

export const FinancesViewer = () => {
    return(
        <div style={{display:'flex'}}>
            <FinancesContainer/>
        </div>
    )
}